export const UI_DISMISS_SHOPIFY_ALERT = 'UI_DISMISS_SHOPIFY_ALERT';

export const dismissShopifyAlert = () => ({ type: UI_DISMISS_SHOPIFY_ALERT });


